export default function getPadding(label: any, padding: any) {
  if (padding) {
    return padding;
  } else if (label) {
    return 'default';
  } else {
    return 'checkbox';
  }
}
